export const tierOneLimit = 3;
export const tierTwoLimit = 10;
export const tieroOnePrice = 29;
export const tierTwoPrice = 20;
export const tierThreePrice = 15;
/** One-time setup fee charged on new Studio subscriptions (USD). */
export const setupFee = 49;
